module.exports = __webpack_public_path__ + "assets/img/td1.dfc14502.png";